export const SHOW_REMAINING_PAGES_LIMIT = 3;
const MINIMUM_IMAGE_WIDTH = 120;
const WIDTH_TO_HEIGHT_RATIO = 1.5;
export const RELATED_CARDS_ROW_MAX_MOBILE = 2;
export const RELATED_CARDS_ROW_MAX_DESKTOP = 4;
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY_MIGRATION: Please fix in passing
export function isArticleSection(entry) {
    return 'article_info' in entry;
}
export const isWideLayout = (mediaItem) => {
    if (!mediaItem) {
        return false;
    }
    if (mediaItem.image_width && mediaItem.image_height) {
        if (mediaItem.image_width < MINIMUM_IMAGE_WIDTH) {
            return false;
        }
        else {
            return mediaItem.image_width >= WIDTH_TO_HEIGHT_RATIO * mediaItem.image_height;
        }
    }
    return true;
};
export const moveMediaItemToUserSelectedMediaItems = (userSelectedMediaItems, allMediaItems, imageUrl, idx) => {
    const updatedMediaItems = [...userSelectedMediaItems];
    const itemToMove = allMediaItems.find((item) => item.image === imageUrl);
    if (itemToMove && idx < updatedMediaItems.length) {
        updatedMediaItems.splice(idx, 1, itemToMove);
    }
    return updatedMediaItems;
};
export const swapMediaItems = (mediaItems, imageUrl, targetIdx) => {
    const updatedMediaItems = [...mediaItems];
    const selectedImageIndex = updatedMediaItems.findIndex((item) => item.image === imageUrl);
    if (selectedImageIndex !== -1 && targetIdx < updatedMediaItems.length) {
        const temp = updatedMediaItems[targetIdx];
        const toMove = updatedMediaItems[selectedImageIndex];
        if (temp && toMove) {
            updatedMediaItems[targetIdx] = toMove;
            updatedMediaItems[selectedImageIndex] = temp;
        }
    }
    return updatedMediaItems;
};
//# sourceMappingURL=ArticleUtils.js.map